import {useAuth} from '@apps-common/auth-react';
import AppsDropdown from '@apps-common/ui-components/NavBar/AppsDropdown.jsx';
import AppsMenu from '@apps-common/ui-components/NavBar/AppsMenu.jsx';
import NavBar from '@apps-common/ui-components/NavBar/NavBar.jsx';
import {useFlags} from 'launchdarkly-react-client-sdk';
import React, {useCallback} from 'react';

import HelpMenu from './help-menu.jsx';
import {reset as resetAnalytics, trackEvent} from '@explorer/analytics';
import {clearState} from '@explorer/blobz/util';
import {DEPLOY_ENV} from '@explorer/config.js';

const TopNavBar = () => {
  const auth = useAuth();
  const {pipShowAppsDropdown: showAppsDropdown} = useFlags();

  const logout = useCallback(() => {
    trackEvent('Logout Button clicked');

    resetAnalytics();
    clearState();

    auth.signOut();
  }, [auth]);

  return (
    <NavBar
      title={
        showAppsDropdown ? (
          <AppsDropdown appKey="explorer" environment={DEPLOY_ENV} />
        ) : (
          'Explorer'
        )
      }
      user={auth.user?.claims}
      appsMenuProps={{
        exclude: 'explorer',
      }}
      secondary={
        <>
          <HelpMenu />
          {!showAppsDropdown && (
            <AppsMenu
              environment={DEPLOY_ENV}
              includeLegacySentinelHubApps={!!auth.user?.claims.sh_user_id}
            />
          )}
        </>
      }
      logout={logout}
      sx={{zIndex: 'modal'}}
      environment={DEPLOY_ENV}
      logoUrl={
        !showAppsDropdown
          ? 'https://www.planet.com/products/planet-insights-platform/'
          : ''
      }
      className="pl-mode-dark"
    />
  );
};

export default TopNavBar;
